import { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import logo from "../../assest/logo.svg";
import useWindowScroll from "../../hooks/useWindowScroll";
import SideMenu from "./SideMenu";
import NavLinks from "./NavLinks";
import NavbarButton from "./NavbarButton";

const Navbar = () => {

	const [isOpen, setIsOpen] = useState(false);
	const scrollY = useWindowScroll();
	const isScrolled = scrollY > 300 && window.innerWidth > 768;
	const shrinkWidth = window.innerWidth > 1200 ? '60%' : '85%';
	const mobileBG = window.innerWidth > 768 ? 'transparent' : 'rgba(0,0,0,0.7)';

	//   Toggle the navbar menu open/closed
	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	return (
		<nav>
			<div
				style={{
					width: isScrolled ? shrinkWidth : "100%",
					height: isScrolled  ? "60px" : "100%",
					backgroundColor: isScrolled ? "rgba(0,0,0,0.7)" : mobileBG,
					borderRadius: isScrolled ? "10px" : "0",
				}}
				className="navbar"
			>
				<div className="logoDiv">
					<img
						src={logo}
						alt="logo"
					/>
				</div>
				<NavLinks />
				<NavbarButton />
				<h2>AAYOJAN</h2>
				<div className="navbar-icon">
					<GiHamburgerMenu onClick={toggleMenu} />
				</div>
				<SideMenu
					isOpen={isOpen}
					toggleMenu={toggleMenu}
				/>
			</div>
		</nav>
	);
};

export default Navbar;
